document.querySelectorAll('.js-back').forEach(btn => {
    btn.addEventListener('click', function (e) {
        const sameOrigin =
            document.referrer &&
            new URL(document.referrer).origin === window.location.origin;

        if (sameOrigin) {
            e.preventDefault();
            history.back();
        }
    });
});
